import React, { useState, Component, lazy } from 'react';
export { default as DgHelmet } from './DgHelmet.mjs';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
export { default as DgPicture } from './DgPicture.mjs';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import { Link, useNavigate } from 'react-router-dom';
export { default as DgHelmetHeader } from './DgHelmetHeader.mjs';
export { LazyLoad as DgLazy, default as DgLazyComponent, useIntersectionObserver as dgIntersectionObserver } from './DgLazyComponent.mjs';
export { dgTag } from './utilityActions.mjs';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import _extends from '@babel/runtime/helpers/extends';
import { ReactReduxContext } from 'react-redux';
import { resolveObj, baseObjStr } from './dgObject.mjs';
export { baseObjStr as dgObjBase, resolveObj as dgResolveObjString, listContainsMultipleObjects, listContainsObject, resolveOrCreateObj } from './dgObject.mjs';
export { default as dgReducerManager } from './dgReducerManager.mjs';
export { default as dgWithLocation } from './dgWithLocation.mjs';
export { propsFnPreFetch as dgPrePropsFn } from './dgPrePropsFn.mjs';
export { default as dgWithReducer } from './dgWithReducer.mjs';
export { default as useFirstRender } from './hooks/useFirstRender.mjs';
export { default as calculateAge } from './age/calculateAge.mjs';
import 'react-helmet';
import 'html-react-parser';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/defineProperty';
import 'redux';

// Components

function AccordianItem(props) {
  var _props$component;

  var _useState = useState(props === null || props === void 0 ? void 0 : props.isExpanded),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  var toggle = function toggle() {
    setStatus(!status);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "dg-accordian-item",
    style: props.containerStyle ? props.containerStyle : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "header",
    onClick: function onClick() {
      return toggle();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, props.title), /*#__PURE__*/React.createElement("div", {
    className: "icon"
  }, !status ? /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "chevron-down",
    className: "svg-inline--fa fa-chevron-down fa-w-14",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
  })) : /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "chevron-up",
    className: "svg-inline--fa fa-chevron-up fa-w-14",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
  })))), /*#__PURE__*/React.createElement("div", {
    className: status ? "body show" : "body hidden"
  }, /*#__PURE__*/React.isValidElement(props === null || props === void 0 ? void 0 : props.component) ? props.component : (_props$component = props.component) === null || _props$component === void 0 ? void 0 : _props$component.call(props, props)));
}

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Components

var Container = /*#__PURE__*/function (_Component) {
  _inherits(Container, _Component);

  var _super = _createSuper$4(Container);

  function Container() {
    _classCallCheck(this, Container);

    return _super.apply(this, arguments);
  }

  _createClass(Container, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "dg-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dg-container-login-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dg-container-header-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dg-container-header"
      }, this.props.header)), /*#__PURE__*/React.createElement("div", {
        className: "dg-container-content"
      }, this.props.content)));
    }
  }]);

  return Container;
}(Component);

var spinner1 = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    margin: "auto",
    background: "none",
    display: "block",
    shapeRendering: "auto"
  },
  width: "200px",
  height: "200px",
  className: "dg-spinner-item",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(0 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "47",
  y: "24",
  rx: "3",
  ry: "6",
  width: "6",
  height: "12",
  fill: "#bb3131"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.9166666666666666s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "47",
  y: "24",
  rx: "3",
  ry: "6",
  width: "6",
  height: "12",
  fill: "#bb3131"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.8333333333333334s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(60 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "47",
  y: "24",
  rx: "3",
  ry: "6",
  width: "6",
  height: "12",
  fill: "#bb3131"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.75s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(90 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "47",
  y: "24",
  rx: "3",
  ry: "6",
  width: "6",
  height: "12",
  fill: "#bb3131"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.6666666666666666s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(120 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "47",
  y: "24",
  rx: "3",
  ry: "6",
  width: "6",
  height: "12",
  fill: "#bb3131"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.5833333333333334s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(150 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "47",
  y: "24",
  rx: "3",
  ry: "6",
  width: "6",
  height: "12",
  fill: "#bb3131"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.5s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "47",
  y: "24",
  rx: "3",
  ry: "6",
  width: "6",
  height: "12",
  fill: "#bb3131"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.4166666666666667s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(210 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "47",
  y: "24",
  rx: "3",
  ry: "6",
  width: "6",
  height: "12",
  fill: "#bb3131"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.3333333333333333s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(240 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "47",
  y: "24",
  rx: "3",
  ry: "6",
  width: "6",
  height: "12",
  fill: "#bb3131"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.25s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(270 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "47",
  y: "24",
  rx: "3",
  ry: "6",
  width: "6",
  height: "12",
  fill: "#bb3131"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.16666666666666666s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(300 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "47",
  y: "24",
  rx: "3",
  ry: "6",
  width: "6",
  height: "12",
  fill: "#bb3131"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "-0.08333333333333333s",
  repeatCount: "indefinite"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(330 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: "47",
  y: "24",
  rx: "3",
  ry: "6",
  width: "6",
  height: "12",
  fill: "#bb3131"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1s",
  begin: "0s",
  repeatCount: "indefinite"
}))));
var gear = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    margin: "auto",
    background: "none",
    display: "block",
    shapeRendering: "auto"
  },
  width: "200px",
  height: "200px",
  viewBox: "0 0 100 100",
  className: "dg-spinner-item",
  preserveAspectRatio: "xMidYMid"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 50)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  values: "0;45",
  keyTimes: "0;1",
  dur: "0.5813953488372093s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.491524206117255 -5.5 L37.491524206117255 -5.5 L37.491524206117255 5.5 L29.491524206117255 5.5 A30 30 0 0 1 24.742744050198738 16.964569457146712 L24.742744050198738 16.964569457146712 L30.399598299691117 22.621423706639092 L22.621423706639096 30.399598299691114 L16.964569457146716 24.742744050198734 A30 30 0 0 1 5.5 29.491524206117255 L5.5 29.491524206117255 L5.5 37.491524206117255 L-5.499999999999997 37.491524206117255 L-5.499999999999997 29.491524206117255 A30 30 0 0 1 -16.964569457146705 24.742744050198738 L-16.964569457146705 24.742744050198738 L-22.621423706639085 30.399598299691117 L-30.399598299691117 22.621423706639092 L-24.742744050198738 16.964569457146712 A30 30 0 0 1 -29.491524206117255 5.500000000000009 L-29.491524206117255 5.500000000000009 L-37.491524206117255 5.50000000000001 L-37.491524206117255 -5.500000000000001 L-29.491524206117255 -5.500000000000002 A30 30 0 0 1 -24.742744050198738 -16.964569457146705 L-24.742744050198738 -16.964569457146705 L-30.399598299691117 -22.621423706639085 L-22.621423706639092 -30.399598299691117 L-16.964569457146712 -24.742744050198738 A30 30 0 0 1 -5.500000000000011 -29.491524206117255 L-5.500000000000011 -29.491524206117255 L-5.500000000000012 -37.491524206117255 L5.499999999999998 -37.491524206117255 L5.5 -29.491524206117255 A30 30 0 0 1 16.964569457146702 -24.74274405019874 L16.964569457146702 -24.74274405019874 L22.62142370663908 -30.39959829969112 L30.399598299691117 -22.6214237066391 L24.742744050198738 -16.964569457146716 A30 30 0 0 1 29.491524206117255 -5.500000000000013 M0 -20A20 20 0 1 0 0 20 A20 20 0 1 0 0 -20",
  fill: "#e15b64"
}))));

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DgSpinner = /*#__PURE__*/function (_Component) {
  _inherits(DgSpinner, _Component);

  var _super = _createSuper$3(DgSpinner);

  function DgSpinner(props) {
    var _this;

    _classCallCheck(this, DgSpinner);

    _this = _super.call(this, props);
    _this.getSpinner = _this.getSpinner.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DgSpinner, [{
    key: "getSpinner",
    value: function getSpinner(type) {
      var tmpType = type.toUpperCase();

      switch (tmpType) {
        case 'CUSTOM':
          return this.props.customSpinner;

        case 'GEAR':
          return gear;

        case 'DEFAULT':
          return spinner1;

        default:
          return spinner1;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "dg-spinner-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dg-spinner"
      }, this.getSpinner(this.props.type || '')));
    }
  }]);

  return DgSpinner;
}(Component);

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DgListOptions = /*#__PURE__*/function (_Component) {
  _inherits(DgListOptions, _Component);

  var _super = _createSuper$2(DgListOptions);

  function DgListOptions(props) {
    var _this;

    _classCallCheck(this, DgListOptions);

    _this = _super.call(this, props);
    _this.state = {
      isDashboardsOpen: false
    };
    return _this;
  }

  _createClass(DgListOptions, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var options = this.props.options.map(function (value, index) {
        return /*#__PURE__*/React.createElement("button", {
          key: "list_option_".concat(value.name, "_").concat(index),
          type: "button",
          className: "dropdown-link",
          onClick: value.onClick
        }, value.icon, /*#__PURE__*/React.createElement("span", {
          className: "link-text"
        }, value.name));
      });
      return /*#__PURE__*/React.createElement("nav", {
        className: "DgListOptions"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "ListOptions-nav"
      }, /*#__PURE__*/React.createElement("li", {
        className: "nav-item ".concat(this.state.isDashboardsOpen ? "show" : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "nav-link dropdown",
        onClick: function onClick() {
          return _this2.setState({
            isDashboardsOpen: !_this2.state.isDashboardsOpen
          });
        }
      }, this.props.icon ? this.props.icon : /*#__PURE__*/React.createElement("svg", {
        "aria-hidden": "true",
        focusable: "false",
        "data-prefix": "fas",
        "data-icon": "ellipsis-v",
        className: "svg-inline--fa fa-ellipsis-v fa-w-6",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 192 512"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z",
        className: "fa-primary"
      })), /*#__PURE__*/React.createElement("div", {
        className: "dropdown-menu ".concat(this.state.isDashboardsOpen ? "show" : '')
      }, options)))));
    }
  }]);

  return DgListOptions;
}(Component);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Actions

var DgLink = /*#__PURE__*/function (_Component) {
  _inherits(DgLink, _Component);

  var _super = _createSuper$1(DgLink);

  function DgLink(props) {
    var _this;

    _classCallCheck(this, DgLink);

    _this = _super.call(this, props);
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DgLink, [{
    key: "onClick",
    value: function onClick(event) {
      event.preventDefault();

      if (this.props.onClick) {
        this.props.onClick;
      }

      window.scrollTo(0, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(Link, {
        to: this.props.to || '/',
        id: this.props.id ? this.props.id : '',
        className: this.props.className ? this.props.className : '',
        onClick: function onClick(e) {
          return _this2.onClick(e);
        },
        replace: this.props.replace,
        innerRef: this.props.innerRef
      }, this.props.children);
    }
  }]);

  return DgLink;
}(Component);

var renderDynamic = function renderDynamic(moduleObj, componentName) {
  if (!componentName || componentName == null || componentName == undefined) {
    // In this case we are exporting the default component
    return /*#__PURE__*/lazy(function () {
      return moduleObj;
    });
  } else {
    if (typeof componentName === 'string' || componentName instanceof String) {
      // In this case one component name has been provided for imporing
      return /*#__PURE__*/lazy(function () {
        return moduleObj.then(function (mod) {
          return {
            "default": mod[componentName]
          };
        });
      });
    } else {
      // In this case an array of multiple named components has been provided for importing
      var rtnObj = {};

      var _loop = function _loop(ii) {
        rtnObj[componentName[ii]] = /*#__PURE__*/lazy(function () {
          return moduleObj.then(function (mod) {
            return {
              "default": mod[componentName[ii]]
            };
          });
        });
      };

      for (var ii = 0; ii < componentName.length; ii++) {
        _loop(ii);
      }

      return rtnObj;
    }
  }
};
var importDynamic = function importDynamic(moduleObj, componentName) {
  if (!componentName || componentName == null || componentName == undefined) {
    return moduleObj.then(function (mod) {
      return mod['default'];
    });
  } else {
    return moduleObj.then(function (mod) {
      return mod[componentName];
    });
  }
};

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var dynamicBaseReducerAdd = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(moduleObj, statePath, store) {
    var parentReducerName,
        state,
        moduleObject,
        baseReducerName,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            parentReducerName = _args.length > 3 && _args[3] !== undefined ? _args[3] : "reducer";
            _context.next = 3;
            return store.getState();

          case 3:
            state = _context.sent;
            _context.next = 6;
            return moduleObj;

          case 6:
            moduleObject = _context.sent;
            // Wait for the module to load if not leaded already
            baseReducerName = baseObjStr(statePath); // Add the base reducer if it doesn't already exist

            if (!(resolveObj(baseReducerName, state) == undefined)) {
              _context.next = 14;
              break;
            }

            store.reducerManager.add(baseReducerName, // Resolve the name the reducer should have
            moduleObject[parentReducerName] // Extract the reducer object from the parent module
            ); // Create a new reducer containing the dynamically added reducer

            store.replaceReducer(store.reducerManager.reduce); // Replace the reducer with the updated reducer just created

            _context.next = 13;
            return store.getState();

          case 13:
            state = _context.sent;

          case 14:
            return _context.abrupt("return", state);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function dynamicBaseReducerAdd(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}(); // Add a state variable to matchsipatchtoprops in a redux container/component which is being imported from an async module

var dynamicStateAccess = function dynamicStateAccess(moduleObj, statePath, state, store) {
  var parentReducerName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "reducer";
  var stateVar = resolveObj(statePath, state);

  if (stateVar != undefined) {
    return stateVar;
  } else {
    // Update the state to add the base reducer if necessary
    return dynamicBaseReducerAdd(moduleObj, statePath, store, parentReducerName).then(function (state) {
      // Query the state path once more with the updated state
      return resolveObj(statePath, state);
    });
  }
};
function withStore(WrappedComponent) {
  var HOC = /*#__PURE__*/function (_React$Component) {
    _inherits(HOC, _React$Component);

    var _super = _createSuper(HOC);

    function HOC(props) {
      _classCallCheck(this, HOC);

      return _super.call(this, props);
    }

    _createClass(HOC, [{
      key: "render",
      value: function render() {
        var _this = this;

        return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (_ref2) {
          var store = _ref2.store;
          return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, _this.props, {
            store: store
          }));
        });
      }
    }]);

    return HOC;
  }(React.Component);

  return HOC;
}

var dynamicActionImport = function dynamicActionImport(moduleObj, actionName, reducerName, props, store) {
  var parentReducerName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'reducer';
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var moduleObject, actionObj;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dynamicBaseReducerAdd(moduleObj, reducerName, store, parentReducerName);

            case 2:
              _context.next = 4;
              return moduleObj;

            case 4:
              moduleObject = _context.sent;
              // Wait for the module to load if not leaded already
              actionObj = moduleObject[actionName]; // Dispatch the action

              return _context.abrupt("return", dispatch(actionObj.apply(void 0, _toConsumableArray(props))));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

// This is needed as navigate can only be obtained by means of a hook
// Therefore this HOC provides the functional component to access navigate

function withNavigate(Component) {
  return function (props) {
    // Obtain the navigate function using the available hook
    var navigate = useNavigate(); // Add the location to the existing props

    var newProps = Object.assign({}, props, {
      navigate: navigate
    });
    return /*#__PURE__*/React.createElement(Component, newProps);
  };
}

export { AccordianItem as DgAccordianItem, Container as DgContainer, DgLink, DgListOptions, DgSpinner, dynamicActionImport as dgAsyncActionImport, renderDynamic as dgAsyncComponent, importDynamic as dgAsyncObject, dynamicStateAccess as dgAsyncStateAccess, withNavigate as dgWithNavigate, withStore as dgWithStore };
